import wcs from '@/scripts/libs/wcs'

export class WcsStoreId {
  static ASEAN = '42652'
  static AUSTRALIA = '33152'
  static AUSTRIA = '26652'
  static BELGIUM = '29152'
  static BRAZIL = '36152'
  static CANADA = '10152'
  static CHINA = '16152'
  static DENMARK = '31652'
  static FINLAND = '32652'
  static FRANCE = '28152'
  static GERMANY = '27652'
  static HONG_KONG = '33652'
  static IRELAND = '30152'
  static ITALY = '26152'
  static JAPAN = '42152'
  static KOREA = '35652'
  static LATAM = '43652'
  static MEXICO = '34153'
  static NETHERLANDS = '29653'
  static NORWAY = '31153'
  static MIDDLE_EAST = '44152'
  static POLAND = '17152'
  static PORTUGAL = '30652'
  static REST_OF_EUROPE = '32652'
  static REST_OF_WORLD = '43152'
  static SPAIN = '28652'
  static SWEDEN = '32152'
  static SWITZERLAND = '16652'
  static TURKEY = '17652'
  static UNITED_KINGDOM = '25653'
  static USA = '10151'

  static INSOURCING = WcsStoreId.USA
  static KLARNA_AFTERPAY_COUTRIES = [WcsStoreId.USA, WcsStoreId.CANADA]

  static mapFacescanRegion = (storeId: string) => {
    switch (storeId) {
      case WcsStoreId.AUSTRALIA:
        return 'AU'
      case WcsStoreId.USA:
        return 'US'
      default:
        return 'EU'
    }
  }

  static readonly NORTH_AMERICA_COUNTRIES = [WcsStoreId.CANADA, WcsStoreId.USA]

  static readonly EUROPEAN_COUNTRIES = [
    WcsStoreId.UNITED_KINGDOM,
    WcsStoreId.SPAIN,
    WcsStoreId.POLAND,
    WcsStoreId.SWITZERLAND,
    WcsStoreId.ITALY,
    WcsStoreId.AUSTRIA,
    WcsStoreId.GERMANY,
    WcsStoreId.FRANCE,
    WcsStoreId.BELGIUM,
    WcsStoreId.NETHERLANDS,
    WcsStoreId.IRELAND,
    WcsStoreId.PORTUGAL,
    WcsStoreId.NORWAY,
    WcsStoreId.DENMARK,
    WcsStoreId.SWEDEN,
    WcsStoreId.FINLAND,
    WcsStoreId.REST_OF_EUROPE,
  ]

  static readonly SOUTH_AMERICA_COUNTRIES = [WcsStoreId.MEXICO, WcsStoreId.BRAZIL]
  static readonly ASIAN_COUNTRIES = [
    WcsStoreId.HONG_KONG,
    WcsStoreId.CHINA,
    WcsStoreId.TURKEY,
    WcsStoreId.KOREA,
    WcsStoreId.JAPAN,
  ]
  static readonly OCEANIA_COUNTRIES = [WcsStoreId.AUSTRALIA]
  // TODO: Map African countries for Exposed API
  static readonly AFRICAN_COUNTRIES = ['00000']

  // TODO: check if this is the correct place to have this array
  static readonly COUNTRIES_WITHOUT_ROX = [
    WcsStoreId.CANADA,
    WcsStoreId.CHINA,
    WcsStoreId.DENMARK,
    WcsStoreId.FINLAND,
    WcsStoreId.FRANCE,
    WcsStoreId.HONG_KONG,
    WcsStoreId.IRELAND,
    WcsStoreId.ITALY,
    WcsStoreId.JAPAN,
    WcsStoreId.KOREA,
    WcsStoreId.NORWAY,
    WcsStoreId.POLAND,
    WcsStoreId.PORTUGAL,
    WcsStoreId.SPAIN,
  ]

  static currentCountryHasRx() {
    const { storeId } = wcs.getStoreConfig()
    return !WcsStoreId.COUNTRIES_WITHOUT_ROX.includes(storeId)
  }

  static currentCountryHasCustomCta() {
    const { storeId } = wcs.getStoreConfig()
    return storeId !== WcsStoreId.ITALY && storeId !== WcsStoreId.KOREA
  }

  static currentCountryIsMultiLanguage = () => {
    const { storeId } = wcs.getStoreConfig()
    const multiLanguageCountries = [
      WcsStoreId.BELGIUM,
      WcsStoreId.CANADA,
      WcsStoreId.HONG_KONG,
      WcsStoreId.SWITZERLAND,
    ]

    return multiLanguageCountries.includes(storeId)
  }
}
